import { render } from "./ConfirmAvatarModal.vue?vue&type=template&id=a8a09eec&scoped=true&ts=true"
import script from "./ConfirmAvatarModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmAvatarModal.vue?vue&type=script&lang=ts"

import "./ConfirmAvatarModal.vue?vue&type=style&index=0&id=a8a09eec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8a09eec"],['__file',"src/components/modals/start/ConfirmAvatarModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8a09eec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8a09eec', __exports__)) {
    api.reload('a8a09eec', __exports__)
  }
  
  module.hot.accept("./ConfirmAvatarModal.vue?vue&type=template&id=a8a09eec&scoped=true&ts=true", () => {
    api.rerender('a8a09eec', render)
  })

}


export default __exports__